export const LOAD_CHECKLIST_STARTED = "LOAD_CHECKLIST_STARTED";
export const LOAD_CHECKLIST_SUCCESS = "LOAD_CHECKLIST_SUCCESS";
